import styled from 'styled-components'
import { FlexChildShrink } from 'components/flex'

export const ButtonColumn = styled(FlexChildShrink)`
    &:not(:last-child) {
        margin-right: 24px;
    }
`
